import { useQueryClient } from 'react-query';
import { QUERY_KEYS, Theme } from '@24i/nxg-sdk-photon';
import { useState } from 'react';
import { log } from '@24i/nxg-core-utils/src/logger';

import { FetchParams, FetchResult } from '../types';
import { useThemeData } from '../../../context/ThemeData';
import { handleError } from '../../../utils/error';

export const useAllThemesFetch = (): FetchResult<Theme[]> => {
    const queryClient = useQueryClient();
    const { fetchAllThemes } = useThemeData();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error | undefined>(undefined);

    const fetch = async (params?: FetchParams): Promise<Theme[]> => {
        try {
            setIsLoading(true);
            setError(undefined);

            if (params?.forceRefresh) {
                await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.appAllThemes] });
            }

            return await queryClient.fetchQuery({
                queryKey: QUERY_KEYS.appAllThemes,
                queryFn: fetchAllThemes,
            });
        } catch (e) {
            const err = handleError(e, 'Failed to fetch all themes');
            setError(err);
            log('Error fetching application themes', err);
            return [];
        } finally {
            setIsLoading(false);
        }
    };

    return { fetch, isLoading, error };
};
